/* EDELHOLZ Produktseiten "Rundgaenge" (30.09.2026), Section edelholz-pdp-rundgaenge.liquid.
   Karte wie assets/edelholz-lp-rundgaenge.js: Klick auf Play, Mediaflaeche waechst sanft von 4:5 auf 9:16, Titel/Text
   blenden aus, Video spielt mit Ton (Ton-Knopf schaltet stumm). Erneuter Klick: Pause, Karte wird wieder 4:5.
   Immer nur ein Video. Poster bleibt sichtbar, bis das erste Bild laeuft (is-bereit).
   Dazu: Desktop "Mehr/Weniger anzeigen" mit halb angeschnittener Reihe, mobil Wisch-Reihe mit Zaehler und Balken
   (Karte aus dem Bild gewischt = Video stoppt), Querformat mobil im echten 16:9 ohne Wachsen.
   Vlog-Knopf: YouTube-iframe (nocookie) erst beim Klick, wie edelholz-video-buehne. */
(function () {
  var mqMobil = window.matchMedia('(max-width: 749px)');
  var RM = false;
  try { RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var SPALTEN = 3;

  function melde(t) {
    /* gleiches Ereignis wie die LP-Rundgaenge (snippets/edelholz-lp-tracking.liquid hoert darauf, wo es geladen ist) */
    try { document.dispatchEvent(new CustomEvent('eh:lp-video', { detail: { chapter: 'Rundgang: ' + t } })); } catch (e) {}
  }

  function init(root) {
    if (!root || root.__ehPr) return; root.__ehPr = true;
    var list = root.querySelector('[data-eh-pr-list]');
    var cards = [].slice.call(root.querySelectorAll('[data-eh-pr-card]'));
    if (!list || !cards.length) return;
    var apis = [];

    function alleStopp(ausser) { apis.forEach(function (a) { if (a !== ausser) a.stopp(); }); }

    /* ---------- Karte ---------- */
    cards.forEach(function (card) {
      var m = card.querySelector('[data-eh-pr-m]'), v = card.querySelector('video'), btn = card.querySelector('[data-eh-pr-play]'), ton = card.querySelector('[data-eh-pr-ton]');
      if (!m || !v || !btn) return;
      var aktiv = false, gemeldet = false, timer = null;
      var titel = ((card.querySelector('.eh-pr__t') || {}).textContent || '').trim();
      var quer = card.classList.contains('is-quer');

      /* Querformat mobil bleibt 16:9 (kein Wachsen), sonst 4:5 -> 9:16 */
      function waechst() { return !(quer && mqMobil.matches); }
      function hoehe(faktor) { return Math.round(m.getBoundingClientRect().width * faktor); }
      function wachse(auf) {
        clearTimeout(timer);
        if (!waechst()) { m.style.height = ''; return; }
        var von = m.getBoundingClientRect().height;
        var ziel = hoehe(auf ? 16 / 9 : 5 / 4);
        if (RM) { m.style.height = auf ? ziel + 'px' : ''; return; }
        m.style.height = von + 'px';
        void m.offsetHeight;
        m.style.height = ziel + 'px';
        if (!auf) timer = setTimeout(function () { if (!aktiv) m.style.height = ''; }, 600);
      }
      function setzeTon(stumm) {
        v.muted = stumm;
        if (ton) { ton.setAttribute('aria-pressed', stumm ? 'true' : 'false'); ton.setAttribute('aria-label', stumm ? 'Ton an' : 'Ton aus'); }
      }
      function laeuft(an) {
        card.classList.toggle('is-laeuft', an);
        btn.setAttribute('aria-label', btn.getAttribute(an ? 'data-label-pause' : 'data-label-play'));
      }
      /* 30.09. (Philipp: "anderes Video angeklickt, startete nicht"): Messung mit gedrosseltem Netz - der Start eines
         neuen Clips dauert mobil mehrere Sekunden (1080p/720p), die Karte war dabei schon gross und zeigte nur das Poster,
         ohne jedes Zeichen. Ausserdem blieb die Karte "aktiv", wenn play() aus einem anderen Grund als "Ton verboten"
         scheiterte. Jetzt: Lade-Kreis bis das Bild laeuft (auch bei Nachladen), Fehler von play() fuehren zu genau einem
         neuen Versuch sobald Daten da sind, ein Waechter laedt nach 12 s ohne Bild neu, danach zurueck in den Ausgangszustand.
         Eigene Pausen (Stopp, aus dem Bild gescrollt) loesen keinen neuen Versuch aus. */
      var eigenePause = false, versuche = 0, waechter = null;
      function lade(an) { card.classList.toggle('is-laedt', !!an); }
      function pausiere() { eigenePause = true; try { v.pause(); } catch (e) {} }
      function einmal(typ, fn) { var h = function () { v.removeEventListener(typ, h); fn(); }; v.addEventListener(typ, h); }
      function spiele() {
        eigenePause = false;
        var p = v.play();
        if (p && p.catch) p.catch(function (err) {
          if (!aktiv || eigenePause) return;
          var name = err && err.name;
          if (name === 'NotAllowedError' && !v.muted) {
            /* Browser verweigert Ton: stumm weiter */
            setzeTon(true); spiele(); return;
          }
          if (versuche < 1) {
            versuche++;
            if (v.readyState >= 3) spiele(); else einmal('canplay', function () { if (aktiv && !eigenePause) spiele(); });
            return;
          }
          zurueck();
        });
      }
      function wache() {
        clearTimeout(waechter);
        waechter = setTimeout(function () {
          if (!aktiv || eigenePause || card.classList.contains('is-bereit') && !v.paused) return;
          if (v.readyState < 2 && versuche < 2) { versuche = 2; try { v.load(); } catch (e) {} spiele(); wache(); return; }
          if (v.readyState < 2) zurueck();
        }, 12000);
      }
      function zurueck() {
        /* nichts ging: Ausgangszustand, Quelle verwerfen, damit der naechste Klick frisch laedt */
        stopp();
        try { v.removeAttribute('src'); v.load(); } catch (e) {}
        card.classList.remove('is-bereit');
      }
      function start() {
        alleStopp(api);
        if (!v.getAttribute('src')) { v.preload = 'auto'; v.src = (mqMobil.matches && v.getAttribute('data-src-m')) || v.getAttribute('data-src'); }
        aktiv = true; versuche = 0;
        /* vom Nutzer gestartet: zaehlt im Beacon fuer act/vid_starts/vid_secs (assets/edelholz-contact-hook.js, nutzerVideo) */
        v.setAttribute('data-eh-nutzer', '');
        /* Mobil: angetippte Karte, die nur am Rand hervorschaut, ganz in die Reihe holen */
        if (mqMobil.matches) {
          var lr = list.getBoundingClientRect(), cr = card.getBoundingClientRect();
          if (cr.left < lr.left - 1 || cr.right > lr.right + 1) {
            var pad = parseFloat(getComputedStyle(list).paddingLeft) || 0;
            try { list.scrollTo({ left: card.offsetLeft - pad, behavior: RM ? 'auto' : 'smooth' }); } catch (e) { list.scrollLeft = card.offsetLeft - pad; }
          }
        }
        card.classList.add('is-aktiv');
        if (v.readyState < 3) lade(true);
        wachse(true);
        setzeTon(false);
        spiele();
        wache();
        laeuft(true);
        if (!gemeldet) { gemeldet = true; melde(titel); }
      }
      function stopp() {
        clearTimeout(waechter);
        lade(false);
        if (!aktiv) return;
        aktiv = false;
        pausiere();
        laeuft(false);
        card.classList.remove('is-aktiv');
        wachse(false);
      }
      function umschalten() {
        if (!aktiv) { start(); return; }
        if (v.paused) { versuche = 0; if (v.readyState < 3) lade(true); spiele(); wache(); laeuft(true); return; }
        stopp();
      }
      btn.addEventListener('click', function (e) { e.stopPropagation(); umschalten(); });
      m.addEventListener('click', function (e) { if (ton && ton.contains(e.target)) return; umschalten(); });
      /* Maus: beim Druecken schon laden (~150 ms Vorsprung). Nicht bei Touch - Wischen ueber Karten soll nichts laden. */
      m.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || (ton && ton.contains(e.target)) || v.getAttribute('src')) return;
        v.preload = 'auto'; v.src = v.getAttribute('data-src');
      });
      if (ton) ton.addEventListener('click', function (e) { e.stopPropagation(); setzeTon(!v.muted); });
      v.addEventListener('ended', function () { stopp(); try { v.currentTime = 0; } catch (e) {} });
      v.addEventListener('pause', function () { lade(false); if (aktiv) laeuft(false); });
      v.addEventListener('play', function () { if (aktiv) laeuft(true); });
      v.addEventListener('waiting', function () { if (aktiv && !v.paused) lade(true); });
      v.addEventListener('playing', function () { lade(false); card.classList.add('is-bereit'); });
      v.addEventListener('error', function () { if (aktiv) zurueck(); });

      if ('IntersectionObserver' in window) {
        /* Senkrecht aus dem Bild: nur pausieren (kein Groessensprung ausserhalb des Blicks), wie LP */
        new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (!en.isIntersecting && aktiv && !v.paused) pausiere(); });
        }, { threshold: 0 }).observe(m);
        /* Mobil seitlich aus der Reihe gewischt: ganz stoppen (Karte geht zurueck auf 4:5) */
        new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (mqMobil.matches && aktiv && en.intersectionRatio < 0.35) stopp(); });
        }, { root: list, threshold: [0, 0.35] }).observe(card);
      }
      var breite = 0;
      window.addEventListener('resize', function () {
        var w = m.getBoundingClientRect().width;
        if (!aktiv || Math.abs(w - breite) < 1) return;
        breite = w;
        if (waechst()) m.style.height = hoehe(16 / 9) + 'px'; else m.style.height = '';
      });

      var api = { stopp: stopp, card: card, aktiv: function () { return aktiv; },
        state: function () { return { aktiv: aktiv, paused: v.paused, muted: v.muted, h: Math.round(m.getBoundingClientRect().height), w: Math.round(m.getBoundingClientRect().width) }; } };
      card._pr = api;
      apis.push(api);
    });

    /* ---------- Desktop: Mehr / Weniger ---------- */
    var mehrBtn = root.querySelector('[data-eh-pr-mehr]');
    var START = Math.max(1, parseInt(root.getAttribute('data-start'), 10) || 1);
    var SCHRITT = Math.max(1, parseInt(root.getAttribute('data-mehr'), 10) || 2);
    var reihenGesamt = Math.ceil(cards.length / SPALTEN);
    var reihen = START;

    function setzeInert(el, an) {
      if (an) { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); }
      else { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); }
    }
    function anwenden(neuAb) {
      var mobil = mqMobil.matches;
      var teaser = false;
      cards.forEach(function (c, i) {
        var r = Math.floor(i / SPALTEN);
        var istTeaser = !mobil && r === reihen;
        var istWeg = !mobil && r > reihen;
        var warVersteckt = c.classList.contains('is-teaser') || c.classList.contains('is-weg');
        c.classList.toggle('is-teaser', istTeaser);
        c.classList.toggle('is-weg', istWeg);
        setzeInert(c, istTeaser || istWeg);
        if (istTeaser) teaser = true;
        if ((istTeaser || istWeg) && c._pr) c._pr.stopp();
        c.classList.remove('is-neu');
        if (!RM && neuAb != null && warVersteckt && !istTeaser && !istWeg && i >= neuAb) { void c.offsetWidth; c.classList.add('is-neu'); }
      });
      list.classList.toggle('has-teaser', teaser);
      if (mehrBtn) {
        var alles = reihen >= reihenGesamt;
        mehrBtn.textContent = mehrBtn.getAttribute(alles ? 'data-label-weniger' : 'data-label-mehr');
        mehrBtn.setAttribute('aria-expanded', alles ? 'true' : 'false');
        mehrBtn.parentNode.hidden = reihenGesamt <= START;
      }
    }
    if (mehrBtn) {
      mehrBtn.addEventListener('click', function () {
        if (reihen >= reihenGesamt) {
          /* Weniger: zuklappen, Knopf bleibt optisch an seiner Stelle, dann sanft zum Anfang der Section */
          var y0 = mehrBtn.getBoundingClientRect().top;
          reihen = START;
          anwenden(null);
          var y1 = mehrBtn.getBoundingClientRect().top;
          var sy = window.pageYOffset || document.documentElement.scrollTop || 0;
          try { window.scrollTo({ top: sy + (y1 - y0), behavior: 'instant' }); } catch (e) { window.scrollTo(0, sy + (y1 - y0)); }
          var ziel = root.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0);
          try { window.scrollTo({ top: Math.max(0, ziel), behavior: RM ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, ziel); }
          return;
        }
        var alt = reihen;
        reihen = Math.min(reihen + SCHRITT, reihenGesamt);
        anwenden(alt * SPALTEN);
      });
    }

    /* ---------- Mobil: Zaehler + Balken ---------- */
    var cnt = root.querySelector('[data-eh-pr-count]'), bar = root.querySelector('[data-eh-pr-bar]');
    var tick = false;
    function position() {
      tick = false;
      if (!mqMobil.matches || !cnt) return;
      var pad = parseFloat(getComputedStyle(list).paddingLeft) || 0;
      var sl = list.scrollLeft, max = list.scrollWidth - list.clientWidth;
      var idx = 0, best = Infinity;
      cards.forEach(function (c, i) { var d = Math.abs(c.offsetLeft - pad - sl); if (d < best) { best = d; idx = i; } });
      if (max > 0 && sl >= max - 4) idx = cards.length - 1;
      cnt.textContent = (idx + 1) + ' / ' + cards.length;
      if (bar) bar.style.transform = 'scaleX(' + ((idx + 1) / cards.length) + ')';
    }
    list.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(position); } }, { passive: true });

    function modus() { alleStopp(null); anwenden(null); position(); }
    if (mqMobil.addEventListener) mqMobil.addEventListener('change', modus); else if (mqMobil.addListener) mqMobil.addListener(modus);
    anwenden(null);
    position();

    /* ---------- Vlog-Fenster (YouTube erst nach Klick) ---------- */
    var ov = root.querySelector('[data-eh-pr-ov]'), ovFrame = root.querySelector('[data-eh-pr-ov-frame]');
    var ovClose = root.querySelector('[data-eh-pr-ov-close]'), ovExt = root.querySelector('[data-eh-pr-ov-ext]');
    var letzterFokus = null, bodyOverflow = '';
    if (ov && ovFrame && ovClose && ovExt) {
      /* Fenster an <body> haengen, damit es nie unter einem transformierten Vorfahren klemmt */
      document.body.appendChild(ov);
      var aufTaste = function (e) {
        if (e.key === 'Escape') { schliesse(); return; }
        if (e.key === 'Tab') {
          var f = [ovClose, ovExt], idx = f.indexOf(document.activeElement);
          if (e.shiftKey && (idx <= 0)) { e.preventDefault(); ovExt.focus(); }
          else if (!e.shiftKey && idx === f.length - 1) { e.preventDefault(); ovClose.focus(); }
        }
      };
      var oeffne = function (id, opener) {
        if (!id) return;
        alleStopp(null);
        var iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
        iframe.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Vlog auf YouTube');
        ovFrame.innerHTML = '';
        ovFrame.appendChild(iframe);
        ovExt.href = 'https://www.youtube.com/watch?v=' + encodeURIComponent(id);
        letzterFokus = opener || document.activeElement;
        bodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        ov.hidden = false;
        document.addEventListener('keydown', aufTaste);
        try { ovClose.focus({ preventScroll: true }); } catch (e) { ovClose.focus(); }
      };
      var schliesse = function () {
        if (ov.hidden) return;
        ovFrame.innerHTML = '';
        ov.hidden = true;
        document.body.style.overflow = bodyOverflow;
        document.removeEventListener('keydown', aufTaste);
        if (letzterFokus && letzterFokus.focus) { try { letzterFokus.focus({ preventScroll: true }); } catch (e) {} }
        letzterFokus = null;
      };
      [].forEach.call(root.querySelectorAll('[data-eh-pr-yt]'), function (b) {
        b.addEventListener('click', function (e) { e.stopPropagation(); oeffne(b.getAttribute('data-eh-pr-yt'), b); });
      });
      ovClose.addEventListener('click', schliesse);
      ov.addEventListener('click', function (e) { if (e.target === ov) schliesse(); });
      root._prOv = { oeffne: oeffne, schliesse: schliesse };
    }
  }

  function alle() { [].forEach.call(document.querySelectorAll('[data-eh-pr]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
  document.addEventListener('shopify:section:load', alle);
})();
